import { render, staticRenderFns } from "./tuandco-blog-results.vue?vue&type=template&id=0e67002c&"
import script from "./tuandco-blog-results.vue?vue&type=script&lang=ts&"
export * from "./tuandco-blog-results.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports